module.exports = __webpack_public_path__ + "img/2.8171522d.jpg";